import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import "primeicons/primeicons.css";
import "primereact/resources/themes/nova-light/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import { Paginator } from "primereact/paginator";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import Modal from 'react-bootstrap/Modal'
import { getMMPLShipInfo } from "../Actions/MMPLDashboardAPI";

class MMPLShipCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      first: 0,
    };
  }

  renderViewPopover(props) {
    return (
      <Popover id="history-tooltip" {...props}>
        <Popover.Content>
          <label style={{ padding: "0px 10px" }}>View</label>
        </Popover.Content>
      </Popover>
    );
  }

  render() {
    const { pageSize, totalRecords } = this.props;

    return (
      <div className="pb-3 mx-4">
        {this.renderCardData()}

        {totalRecords !== 0 ? (
          <Paginator
            first={this.state.first}
            rows={pageSize}
            totalRecords={totalRecords}
            onPageChange={(e) => this.onPaginatorChange(e)}
          ></Paginator>
        ) : (
            <div className="card" style={{ overflow: "hidden", position: "relative" }}>
              <div class="container">
                <h6 className="resource-list-title no-item-card">
                  No Ships
              </h6>
              </div>
            </div>
          )}
      </div>
    );
  }

  onPaginatorChange(event) {
    const { setUpdatedState } = this.props;
    this.setState({ first: event.first });
    setUpdatedState(event.page + 1);
  }

  renderCardData = () => {
    const { arraylist } = this.props;
    return arraylist && arraylist.length
      ? arraylist.map((item, index) => {
        return (
          <div className="card" style={{ overflow: "hidden", position: "relative" }}>
            <div className="px-3 py-2">
              <div className="resource-list-auth-date">
                <div className="row">
                  <div className="col-sm-10 col-10 col-m-auto col-md-11">
                    <div className="row">
                      <div className="col-sm-6 col-md-6">
                        <h6 className="resource-list-title m-auto" onClick={() => this.ShowSidePanel(item.shipId, item)}>
                          {item.vesselName !== "" ? item.vesselName : "Ship Name"}
                        </h6>
                      </div>
                      <div className="col-sm-2 col-md-2">
                        <span>
                          <strong>IMO No : </strong>
                          <span className="italicFont click" onClick={() => this.ShowSidePanel(item.shipId, item)}>
                            {item.imoNo ? item.imoNo : ""}
                          </span>
                        </span>
                      </div>
                      <div className="col-sm-2 col-md-2">
                        <span>
                          <strong>Class : </strong>
                          <i aria-hidden="true"></i>
                          <span className="italicFont click" onClick={() => this.ShowSidePanel(item.shipId, item)}>
                            {item.className ? item.className : ""}
                          </span>
                        </span>
                      </div>
                      <div className="col-sm-2 col-md-2">
                        <span>
                          <strong>Flag : </strong>
                          <span className="italicFont click" onClick={() => this.ShowSidePanel(item.shipId, item)}>
                            {item.flagName ? item.flagName : ""}
                          </span>
                        </span>
                      </div>
                    </div>
                  </div >

                  <div className="col-sm-2 col-md-1 col-2 col-m-auto text-right">
                    {/* <OverlayTrigger
                      placement="bottom"
                      delay={{ show: 250, hide: 400 }}
                      overlay={this.renderViewPopover()}> */}
                    <i
                      className="fa fa-eye click mr-2"
                      aria-hidden="true"
                      onClick={() => this.ShowSidePanel(item.shipId, item)}
                      style={{ color: " #1E3A8A", fontSize: '30px' }}>
                    </i>
                    {/* </OverlayTrigger> */}
                  </div >
                </div >
              </div >
            </div >
          </div >
        );
      })
      : null;
  };

  ShowSidePanel = (id, item) => {
    this.props.dispatch({ type: 'Staff', data: false });
    this.props.dispatch({ type: "Shipment Library", data: false });
    this.props.dispatch({ type: "ShipRole", data: "MMPL" });
    this.props.dispatch({ type: "ShipDetails", data: item });
    this.props.dispatch({ type: "ShowShipView", data: true });
    localStorage.setItem("shipId", id)
    this.props.history.push(`/Home/Ship/${id}/Tasks`);
  };

}

function mapStateToProps(state) {
  return {
    showMMPLDetailsPane: state.SidePanReducer.ShowMMPLDetails || false,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(MMPLShipCard)
);
